import { intersection } from 'ramda';

const hasSome = <T>(items?: T[], ...requiredItems: T[]): boolean =>
  intersection(items || [], requiredItems).length > 0;

export default hasSome;
